// NotificationPopup.tsx (Example Component)

import React from 'react';
import { useMeeting } from '../contexts/MeetingContext'; // Adjust path

const NotificationPopup: React.FC = () => {
  const { notificationMessage, clearNotification } = useMeeting();

  if (!notificationMessage) return null;

  // Basic styling for a simple popup (Use your preferred CSS/Tailwind/Component Library)
  const popupStyle: React.CSSProperties = {
    position: 'fixed',
    top: '20px',
    right: '20px',
    backgroundColor: notificationMessage.startsWith('Error') ? '#f44336' : '#4CAF50',
    color: 'white',
    padding: '15px',
    borderRadius: '5px',
    zIndex: 1000,
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  };

  const closeButtonStyle: React.CSSProperties = {
    marginLeft: '10px',
    cursor: 'pointer',
    backgroundColor: 'transparent',
    border: 'none',
    color: 'white',
    fontWeight: 'bold',
  };

  return (
    <div style={popupStyle}>
      {notificationMessage}
      <button style={closeButtonStyle} onClick={clearNotification}>
        &times;
      </button>
    </div>
  );
};

export default NotificationPopup;